import {
  forwardRef,
  type InputHTMLAttributes,
  type LabelHTMLAttributes,
  type ReactNode,
} from 'react';

import { cn } from '../../lib/utils.js';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...props },
  ref,
) {
  return <input ref={ref} type="checkbox" className={cn('check', className)} {...props} />;
});

export interface CheckboxRowProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
}

export function CheckboxRow({ children, className, ...props }: CheckboxRowProps) {
  return (
    <label className={cn('check-row', className)} {...props}>
      {children}
    </label>
  );
}
